module.exports = __webpack_public_path__ + "static/media/menu-icon-opened.229b1b71.svg";